<template>
	<div class="vl2">
		<!-- 页面头部 - 更加大气的设计 -->
		<!-- <div class="header">
			<div class="header-content">
				<h1>探索城市酒店</h1>
				<p>发现全国各大城市的优质酒店，享受舒适便捷的住宿体验</p>
			</div>
		</div> -->

		<!-- 主内容区域 - 添加模糊背景效果 -->
		<div class="content-wrapper">
			<!-- 搜索区域 -->
			<div class="search-container">
				<input v-model="searchText" placeholder="搜索城市或酒店名称" prefix-icon="el-icon-search" clearable
					@input="handleSearch"></input>
			</div>

			<!-- 城市列表区域 -->
			<div class="city-list" v-if="filteredCities.length > 0">
				<div v-for="city in filteredCities" :key="city.id" class="city-item">
					<div class="city-header" :class="{ collapsed: collapsedCities.includes(city.id) }"
						@click="toggleCity(city.id)">
						<span>{{ city.name }} ({{ getFilteredHotelCount(city.id) }}家酒店)</span>
						<!-- <i class="el-icon-arrow-down"></i> -->
						<img src="../resource/vl_1.png" alt="" />
					</div>

					<div class="hotel-list" v-show="!collapsedCities.includes(city.id)">
						<div v-for="(hotel,hotel_index) in getFilteredHotels(city.id)" :key="hotel.id" :class="[{'hotel-itemNO':hotel_index==0},'hotel-item']">
							<div class="hotel-info">
								<div class="hotel-name">{{ hotel.name }}</div>
								<div class="hotel-address"> {{ hotel.address }}</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<!-- 无结果提示 -->
			<div class="no-results" v-else>
				<div>暂无匹配的城市或酒店</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	// import Element from '../common/index.js';
	export default {
		data() {
			return {
				cities: [],
				searchText: '',
				collapsedCities: [0] ,// 默认只展开北京
			}
		},
		computed: {
			// 过滤后的城市列表
			filteredCities() {
				if (!this.searchText.trim()) {
					return this.cities;
				}

				const searchLower = this.searchText.toLowerCase();
				return this.cities.filter(city => {
					// 城市名匹配或包含匹配的酒店
					return city.name.toLowerCase().includes(searchLower) ||
						this.getFilteredHotels(city.id).length > 0;
				});
			}
		},
		mounted() {
			this.getVenusList()
		},
		methods: {
			sortCities(cities) {
			    // 定义需要排在前面的城市及其顺序
			    const priorityCities = ['北京市', '上海市', '广州市', '深圳市'];
			    
			    // 创建一个映射，为每个优先级城市分配一个排名值
			    const cityRank = {};
			    priorityCities.forEach((city, index) => {
			        cityRank[city] = index;
			    });
			    
			    // 返回排序后的城市数组
			    return cities.sort((a, b) => {
			        // 如果 a 是优先级城市，b 不是，则 a 排在前面
			        if (cityRank.hasOwnProperty(a) && !cityRank.hasOwnProperty(b)) {
			            return -1;
			        }
			        // 如果 b 是优先级城市，a 不是，则 b 排在前面
			        if (cityRank.hasOwnProperty(b) && !cityRank.hasOwnProperty(a)) {
			            return 1;
			        }
			        // 如果 a 和 b 都是优先级城市，则按照定义的顺序排列
			        if (cityRank.hasOwnProperty(a) && cityRank.hasOwnProperty(b)) {
			            return cityRank[a] - cityRank[b];
			        }
			        // 如果 a 和 b 都不是优先级城市，则保持原顺序或按其他规则排序
			        return 0; // 或者使用其他排序规则，如字母顺序：a.localeCompare(b);
			    });
			},
			getVenusList(){
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getVenueList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						// console.log(venus_lst);
						var cityb=[]
						res.data.map((item)=>{
							cityb.push(item.city)
						})
						cityb=Array.from(new Set(cityb))
						// console.log(cityb);
						
						var city=$this.sortCities(cityb)
						// console.log(city);
						// 
						// return
						var venus_lst=[]
						city.map((item)=>{
							var params={
								city:item,
								name:item.slice(0, -1),
								hotels:[]
							}
							venus_lst.push(params)
						})
						// console.log(venus_lst);
						
						// return
						venus_lst.map((item_1,index_1)=>{
							item_1.id=index_1
							res.data.map((item_2)=>{
								if(item_1.city==item_2.city){
									item_2.name=item_2.venue_name
									item_1.hotels.push(item_2)
								}
							})
						})
						console.log(venus_lst);
						
						var collapsedCities=[]
						venus_lst.map((item,index)=>{
							if(index>0){
								collapsedCities.push(item.id)
							}
							
						})
						
						$this.cities=venus_lst
						$this.collapsedCities=collapsedCities
					}).catch((error) => {
						console.warn(error)
						$this.$toast(error.msg?error.msg:error.message?error.message:"获取用户信息失败");
					})
			},
			
			
			// 切换城市折叠状态
			toggleCity(cityId) {
				const index = this.collapsedCities.indexOf(cityId);
				// console.log(index);
				// return
				if (index > -1) {
					this.collapsedCities.splice(index, 1);
				} else {
					this.collapsedCities.push(cityId);
				}
			},

			// 获取过滤后的酒店列表
			getFilteredHotels(cityId) {
				if (!this.searchText.trim()) {
					return this.cities.find(c => c.id === cityId).hotels || [];
				}

				const searchLower = this.searchText.toLowerCase();
				const city = this.cities.find(c => c.id === cityId);
				if (!city) return [];

				return city.hotels.filter(hotel =>
					hotel.name.toLowerCase().includes(searchLower) ||
					hotel.address.toLowerCase().includes(searchLower)
				);
			},

			// 获取过滤后的酒店数量
			getFilteredHotelCount(cityId) {
				return this.getFilteredHotels(cityId).length;
			},

			// 处理搜索
			handleSearch() {
				// 搜索时自动展开所有包含结果的城市
				this.collapsedCities = [];
				if (this.searchText.trim()) {
					this.filteredCities.forEach(city => {
						if (this.getFilteredHotelCount(city.id) === 0) {
							this.collapsedCities.push(city.id);
						}
					});
				} else {
					// 清空搜索时恢复默认折叠状态
					this.collapsedCities = [2, 3, 4, 5];
				}
			}
		}
	}
</script>
<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.vl2{
		background-color: #FFF3E8;
		padding: 30*@vm_base;
		min-height: 100vh;
	}
	.container {
		max-width: 1200*@vm_base;
		margin: 0 auto;
		padding: 40*@vm_base 20*@vm_base;
		position: relative;
		z-index: 1;
	}

	/* 背景模糊遮罩 */
	.content-wrapper {
		// backdrop-filter: blur(10*@vm_base);
		// -webkit-backdrop-filter: blur(10*@vm_base);
		// background: rgba(255, 255, 255, 0.95);
		// border-radius: 20*@vm_base;
		// box-shadow: 0 20*@vm_base 40*@vm_base rgba(0, 0, 0, 0.1);
		// overflow: hidden;
		// border: 1*@vm_base solid rgba(255, 255, 255, 0.2);

		.header {
			position: relative;
			background: linear-gradient(135deg, rgba(255, 159, 69, 0.9), rgba(255, 215, 0, 0.9)),
				url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><rect fill="none" width="100" height="100" stroke="rgba(255,255,255,0.1)" stroke-width="1"/></svg>');
			background-size: cover;
			background-position: center;
			color: white;
			padding: 80*@vm_base 20*@vm_base;
			text-align: center;
			border-radius: 20*@vm_base;
			margin-bottom: 20*@vm_base;
			box-shadow: 0 20*@vm_base 60*@vm_base rgba(0, 0, 0, 0.2);
			overflow: hidden;
		}

		.header::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
			z-index: 1;
		}

		.header-content {
			position: relative;
			z-index: 2;
		}

		.header h1 {
			margin: 0;
			font-size: 2.5rem;
			font-weight: 600;
			letter-spacing: 1*@vm_base;
		}

		.header p {
			margin-top: 10*@vm_base;
			font-size: 1.2rem;
			opacity: 0.9;
		}

		.search-container {
			padding: 30*@vm_base 0;
			text-align: center;
			border-bottom: 1*@vm_base solid rgba(0, 0, 0, 0.05);
		}

		.search-container input {
			width: 100%;
			margin: 0 auto;
			height: 80*@vm_base;
			font-size: 28*@vm_base;
			border: none;
			outline: none;
			padding: 0 20*@vm_base;
			border-radius: 16*@vm_base;
		}

		.city-list {
			padding: 30*@vm_base 0;
		}

		.city-item {
			// border-bottom: 1*@vm_base solid rgba(0, 0, 0, 0.05);
			padding: 0;
			margin-bottom: 20*@vm_base;
			border-radius: 15*@vm_base;
			overflow: hidden;
			box-shadow: 0 5*@vm_base 15*@vm_base rgba(0, 0, 0, 0.02);
			transition: box-shadow 0.3s ease;
			background: linear-gradient(180deg, #FFE2C8 0%, rgba(255, 226, 200, 0.5) 100%);
		}

		.city-item:hover {
			box-shadow: 0 10*@vm_base 30*@vm_base rgba(0, 0, 0, 0.05);
		}

		.city-item:last-child {
			border-bottom: none;
			margin-bottom: 0;
		}

		.city-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
			font-size: 1.3rem;
			font-weight: 600;
			color: #303133;
			padding: 20*@vm_base 25*@vm_base;
			transition: all 0.3s ease;
			background: rgba(255, 159, 69, 0.05);
			font-size: 28*@vm_base;
		}

		.city-header:hover {
			color: #FF9F45;
			background: rgba(255, 159, 69, 0.08);
		}

		.city-header img {
			width: 30*@vm_base;
			// transform: rotate(0deg);
			transition: transform 0.3s ease;
			color: #FF9F45;
		}

		.city-header.collapsed img {
			transform: rotate(-180deg);
		}

		.hotel-list {
			animation: slideDown 0.3s ease-out;
			background: rgba(255, 255, 255, 0.7);
		}

		@keyframes slideDown {
			from {
				opacity: 0;
				max-height: 0;
			}

			to {
				opacity: 1;
				max-height: 1000*@vm_base;
			}
		}

		.hotel-item {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding: 20*@vm_base 25*@vm_base;
			// background: rgba(255, 255, 255, 0.85);
			// border-radius: 15*@vm_base;
			// backdrop-filter: blur(10*@vm_base);
			// box-shadow: 0 8*@vm_base 32*@vm_base rgba(0, 0, 0, 0.1);
			transition: all 0.3s ease;
			border-top: 1*@vm_base solid rgba(0, 0, 0, 0.05);
			width: 100%;
			// box-sizing: border-box;
		}
		.hotel-itemNO{
			border-top: 1*@vm_base solid transparent;
		}

		.hotel-item:hover {
			background-color: rgba(255, 159, 69, 0.03);
		}

		.hotel-item:last-child {
			border-bottom: none;
		}

		.hotel-info {
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: 5*@vm_base;
			text-align: left;
		}

		.hotel-name {
			width: 100%;
			font-size: 26*@vm_base;
			color: #7C4B24;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.hotel-address {
			padding-left: 34*@vm_base;
			background-image: url(../resource/vl_2.png);
			background-size:auto 28*@vm_base;
			background-position: left top;
			background-repeat: no-repeat;
			font-size: 24*@vm_base;
			color: rgba(124,75,36,0.7);
			line-height: 1.2;
			margin-top: 14*@vm_base;
		}



		.no-results {
			text-align: center;
			padding: 80*@vm_base 20*@vm_base;
			color: #909399;
			background: white;
			border-radius: 15*@vm_base;
			margin: 20*@vm_base;
		}

		.no-results div {
			font-size: 1.2rem;
			padding: 20*@vm_base;
			background: rgba(255, 159, 69, 0.05);
			border-radius: 10*@vm_base;
			display: inline-block;
		}

		/* H5响应式设计 */
		// @media (max-width: 768*@vm_base) {
		// 	.container {
		// 		padding: 10*@vm_base;
		// 	}

		// 	.header {
		// 		padding: 40*@vm_base 15*@vm_base;
		// 	}

		// 	.header h1 {
		// 		font-size: 2rem;
		// 	}

		// 	.header p {
		// 		font-size: 1rem;
		// 	}

		// 	.search-container {
		// 		padding: 15*@vm_base;
		// 	}

		// 	.city-list {
		// 		padding: 15*@vm_base;
		// 	}

			
		// }
	}
</style>


// WEBPACK FOOTER //
// src/views/venus_list2.vue